import React from 'react';

import {IdcardOutlined} from '@ant-design/icons/lib';
import {Button, Card} from 'antd';
import {resetPassword} from 'aws-amplify/auth';
import type {FormikProps} from 'formik';
import {withFormik} from 'formik';
import {Form, FormItem, Input} from 'formik-antd';
import * as yup from 'yup';

import {AnchorLink} from '../AnchorLink';

import {Extra} from './Shared';

import {getErrorInfo} from 'lib/errorUtils';
import type {IAuthProps} from 'types';
import {AuthState} from 'types';

interface IFormValues {
  email: string;
}

// eslint-disable-next-line react-refresh/only-export-components
const C: React.FC<FormikProps<IFormValues> & IAuthProps> = ({
  isSubmitting,
  setState: setStateCallback,
  values
}) => {
  const setState = setStateCallback;
  const backToSignIn = (e: React.SyntheticEvent) => {
    e.preventDefault();
    setState({authState: AuthState.signIn, email: values.email});
  };
  const goToSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    setState({authState: AuthState.forgotPasswordSubmit});
  };
  return (
    <Card
      title="Reset your password"
      extra={<AnchorLink onClick={backToSignIn}>Back to Sign In</AnchorLink>}>
      <Form layout="vertical">
        <FormItem name="email" label="Email">
          <Input autoFocus name="email" type="email" size="large" prefix={<IdcardOutlined />} />
        </FormItem>
        <Button block size="large" type="primary" loading={isSubmitting} htmlType="submit">
          Send code
        </Button>
        <Extra>
          <AnchorLink onClick={goToSubmit}>I already have a code</AnchorLink>
        </Extra>
      </Form>
    </Card>
  );
};

const schema = yup.object().shape({
  email: yup.string().email().required()
});

export const ForgotPassword = withFormik<IAuthProps, IFormValues>({
  validationSchema: schema,
  mapPropsToValues: ({email = ''}) => ({email}),
  handleSubmit: async ({email}, {props, setErrors, setSubmitting}) => {
    try {
      await resetPassword({username: email});
      props.setState({authState: AuthState.forgotPasswordSubmit, email});
    } catch (error: unknown) {
      // Safely extract error information
      const {name: errorName, message: errorMessage} = getErrorInfo(error);

      if (errorName === 'UserNotFoundException') {
        setErrors({email: 'Email does not exist'});
        return;
      }
      setErrors({email: errorMessage});
    } finally {
      setSubmitting(false);
    }
  }
})(C);
